import type { default as Candidate } from 'model/Candidate';
import type { Location } from 'shared/legacy/contexts/SearchContext/FiltersContext/types';
import type { CandidateLocation } from './types';

import { getClosestLocation } from 'utils/candidates/getClosestLocation';
import { calculateGeographicDistance } from 'utils/shared/calculateGeographicDistance';

export const extractLocation = (candidate: Candidate, locations: Location[]): CandidateLocation | undefined => {
  if (!candidate.location) return undefined;

  const closestLocation = getClosestLocation(candidate.location.latlon, locations);
  const locationDistance =
    closestLocation && candidate.location?.latlon
      ? `${calculateGeographicDistance(candidate.location.latlon, closestLocation).toFixed(0)}km`
      : undefined;

  return {
    name: candidate.location.name,
    distance: locationDistance,
  };
};
